export function initConsentMap() {
    const container = document.getElementById('consent-map');
    if (!container) return;

    const btn = container.querySelector('.consent-map__btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
        const src = container.dataset.src;
        if (!src) return;
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'lazy');
        container.innerHTML = '';
        container.appendChild(iframe);
    });
}
